import React, { useRef, FormEvent } from 'react';
import { io, Socket } from 'socket.io-client';

interface Login {
	mode: string;
	username: string;
	onLogin: (username: string, socket: Socket | null) => void;

	/* Layering violation!  Need a separate panel or something. */
	onChoose: (room: string) => void;
}

export default function Login({mode, username, onLogin, onChoose}: Login) {
	const usernameRef = useRef<HTMLInputElement>(null);

	function onLogoutClick() {
		onLogin("", null);
	}

	function onSubmit(e: FormEvent): void {
		e.preventDefault();
		const username_ = usernameRef.current!.value.trim();
		if (username_ == "")
			return;
//		const socket = io("http://localhost:3500");
		const socket = io({
			path: "/poker/casino",
			auth: { helloMessage: username_ }
		});
		onLogin(username_, socket);
	}

	if (username != "") {
		const leaveButton = (mode != "game") ? <> </> : (
			<button onClick={() => onChoose("")}>
				End game
			</button>
		)
		return (
			<div className="logout">
				Logged in as {username}.
				<button onClick={onLogoutClick}>
					Log out
				</button>
				{leaveButton}
			</div>
		);
	}

	const instructions = (<>
		<h2>Scotch Hold&apos;em Poker Rules</h2>
		<ol>
		<li>Every player gets a hand between 0 and 1000.</li>

		<li>If all players can agree to a split of 1, then the game
		    ends.
		</li>

		<li>If any player aborts negotiations, then play proceeds to
		    showdown:
		</li>

			<ol>
			<li>All players win a showdown bonus of 0.1 / n, where n
			    is the number of players.
			</li>

			<li>All players&apos; hands, and the community card are
			    revealed.  The community card is a number between 0%
			    and 100%.
			</li>

			<li>The player with the best hand wins the showdown, but
			    only if his hand wins even after being handicapped
			    by multiplying it with the community card.
			</li>

			<li>The winner (if any) wins 1 in addition to the
			    showdown bonus.
			</li>
			</ol>
		</ol>
	</>)

	return(
		<>
			<h1>Welcome to Scotch Hold&apos;em Poker</h1>
			<p>By Andrew Clausen and Christopher Stapenhurst</p>
			<form onSubmit={onSubmit}>
			<label>
			<p>Choose a nick name:</p>
			<input type="text" ref={usernameRef} autoFocus/>
			</label>
			<div>
			<button type="submit">
				Enter
			</button>
			</div>
			</form>
			{instructions}
		</>
	)
}

